import styled from "styled-components"
import { getCssSizeValue } from "@/utils/utils"
import { BREAKPOINTS } from "@/styles/themeSettings"

const StyledAssetWrapper = styled.div`
	position: absolute;
	top: 0;
	left: 0;
	z-index: 1;
	width: 100%;
	height: 100%;

	figure {
		height: 100%;
	}

	transition: opacity 0.2s;

	&.hide {
		opacity: 0;
		pointer-events: none;
	}

	&.show {
		opacity: 1;
	}

	&.above {
		z-index: 3;
	}

	&.thumbnail {
		display: none;

		transition: all 0.6s;

		@media (min-width: ${({ theme }) => theme.breakpoints[BREAKPOINTS.DESKTOP]}px) and (orientation: landscape) {
			overflow: hidden;
			cursor: pointer;
			transform-origin: bottom right;
			&:hover:not(.expanded) {
				transform: scale(1.2);
			}

			aspect-ratio: 1;
			display: initial;
			top: unset;
			left: unset;
			bottom: ${getCssSizeValue(48)};
			right: var(--paddingX);
			height: ${getCssSizeValue(250)};
			width: ${getCssSizeValue(250)};
			z-index: 10;

			.video-cover {
				border-radius: 50%;
			}

			&.expanded {
				aspect-ratio: unset;
				translate: var(--paddingX) ${getCssSizeValue(48)};
				width: 100%;
				height: 100%;
			}
		}
	}
`

export default function AssetWrapper({ children, ...props }) {
	return <StyledAssetWrapper {...props}>{children}</StyledAssetWrapper>
}
